var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
      },
      [_c("v-page-loading")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading",
          },
        ],
      },
      [
        _c("v-page-header", { attrs: { title: _vm.getPageTile } }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasLoadingError,
                expression: "hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("p", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.loadingError)),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasLoadingError,
                expression: "!hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("div", { staticClass: "grid-x" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "cell medium-9 medium-offset-1 large-11 large-offset-0",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wrapper" },
                      [
                        _c("v-action-buttons", {
                          attrs: {
                            items: _vm.getActionButtons,
                            isDisabled:
                              _vm.projectFormDisabled || _vm.isCancelled,
                          },
                          on: { actionClicked: _vm.onClickAction },
                        }),
                        _vm._v(" "),
                        _c("v-form-message", {
                          attrs: {
                            type: "error",
                            id: "form-error",
                            message: _vm.projectObjectError,
                            autoCloseTimeout: 5000,
                          },
                          on: {
                            onClickAction: _vm.onClickActivateDialogAction,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-form-message", {
                          attrs: {
                            type: "success",
                            id: "form-success",
                            message: _vm.projectObjectSuccess,
                          },
                          on: {
                            onClickAction: _vm.onClickActivateDialogAction,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-form-message", {
                          attrs: {
                            type: "default",
                            id: "form-activate",
                            message: _vm.projectObjectActivate,
                            autoCloseTimeout: 0,
                            showActionButtons: true,
                          },
                          on: {
                            onClickAction: _vm.onClickActivateDialogAction,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-form-message", {
                          attrs: {
                            type: "default",
                            message: _vm.objectCheckTOK,
                            autoCloseTimeout: 0,
                            showActionButtons: true,
                          },
                          on: { onClickAction: _vm.onClickDialogAction },
                        }),
                        _vm._v(" "),
                        _vm.isDuplicateMethod
                          ? _c("div", { staticClass: "grid-x grid-margin-x" }, [
                              _c(
                                "div",
                                { staticClass: "cell medium-9 large-12" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "callout warning text-center",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "form.project.duplicate.message"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$store.getters.userIsAdmin &&
                        _vm.missingGeoCoordinates
                          ? _c("div", { staticClass: "grid-x grid-margin-x" }, [
                              _c(
                                "div",
                                { staticClass: "cell medium-9 large-12" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "callout warning text-center",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("project.error.nogeolocation")
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "grid-x grid-margin-x" }, [
                          _c("div", { staticClass: "cell medium-12 large-6" }, [
                            _c("div", { staticClass: "box" }, [
                              _c(
                                "div",
                                { staticClass: "grid-x grid-margin-x" },
                                [
                                  _c("div", { staticClass: "cell small-3" }, [
                                    _c("h2", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("form.project.title.project")
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm.$store.getters.userIsAdmin
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cell small-6 project-detail-status",
                                          },
                                          [
                                            _vm.object.location.risk
                                              ? [
                                                  _vm.object.location.risk
                                                    .is_valid &&
                                                  _vm.object.location.risk
                                                    .decided_budget
                                                    ? _c("p", [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "\n                                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "location.risk.limit"
                                                                )
                                                              ) +
                                                              ": " +
                                                              _vm._s(
                                                                _vm.$helpers.formateCurrency(
                                                                  _vm.object
                                                                    .location
                                                                    .risk
                                                                    .decided_budget
                                                                )
                                                              ) +
                                                              "\n                                "
                                                          ),
                                                        ]),
                                                      ])
                                                    : _c("p", [
                                                        _c(
                                                          "strong",
                                                          {
                                                            staticClass:
                                                              "u-color--alert",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "location.risk.not_valid"
                                                                  )
                                                                ) +
                                                                "\n                                "
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                ]
                                              : [
                                                  _c("p", [
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "u-color--alert",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "location.risk.no_risk_number"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ],
                                          ],
                                          2
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "cell small-3 text-right" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "c-project-toolbar" },
                                        [
                                          _vm.$store.getters.userIsAdmin
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-project-weekplan-calendar",
                                                },
                                                [
                                                  _c(
                                                    "tippy",
                                                    {
                                                      attrs: {
                                                        arrow: "",
                                                        theme: "light-border",
                                                        trigger: "click",
                                                        animateFill: "false",
                                                        interactive: "",
                                                        placement: "bottom",
                                                        animation: "fade",
                                                        maxWidth: "800",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "trigger",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "weekplan-calendar",
                                                                    attrs: {
                                                                      title:
                                                                        _vm.$t(
                                                                          "weeks.update.title"
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "weeks.update.title"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        1047477397
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _vm.object.id
                                                        ? _c("v-weekplans", {
                                                            attrs: {
                                                              projectId:
                                                                _vm.object.id,
                                                              projectLayers:
                                                                _vm.object
                                                                  .layers,
                                                            },
                                                            on: {
                                                              pushWeekplans:
                                                                _vm.handleWeekplans,
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "project-detail-status",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "status-icon",
                                                  class:
                                                    "status-icon--" +
                                                    _vm.object.status,
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "status." +
                                                          _vm.object.status
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.isCancelled
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "project-detail-status__cancelled-date",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "am " +
                                                            _vm._s(
                                                              _vm._f("moment")(
                                                                _vm.object
                                                                  .modifiedon
                                                                  .date,
                                                                _vm.$helpers.dateFormat.toUpperCase()
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "grid-x grid-margin-x" },
                                [
                                  _c("div", { staticClass: "cell small-12" }, [
                                    _vm.object.tour_routes
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "u-extra-small-margin--bottom",
                                            staticStyle: {
                                              "white-space": "nowrap",
                                            },
                                          },
                                          _vm._l(
                                            _vm.object.tour_routes,
                                            function (route, index) {
                                              return _c(
                                                "p",
                                                {
                                                  key: index,
                                                  staticClass: "u-no-margin",
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "u-icon--announcement",
                                                      attrs: {
                                                        role: "presentation",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        attrs: {
                                                          "xlink:href":
                                                            "/dist/sprite.svg#icon-announcement",
                                                          href: "/dist/sprite.svg#icon-announcement",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("kolonne.title")
                                                      ) +
                                                        ": " +
                                                        _vm._s(route.kolonne) +
                                                        ", " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tours.expecteddate"
                                                          )
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.$t("tours.from")
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            route.tour_startdate,
                                                            "DD.MM.YYYY"
                                                          )
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.$t("tours.till")
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            route.tour_enddate,
                                                            "DD.MM.YYYY"
                                                          )
                                                        )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.weekplans
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "u-extra-small-margin--bottom",
                                          },
                                          _vm._l(
                                            _vm.weekplans,
                                            function (entry, index) {
                                              return _c(
                                                "p",
                                                {
                                                  key: index,
                                                  staticClass: "u-no-margin",
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "u-icon--announcement",
                                                      attrs: {
                                                        role: "presentation",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        attrs: {
                                                          "xlink:href":
                                                            "/dist/sprite.svg#icon-announcement",
                                                          href: "/dist/sprite.svg#icon-announcement",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("kolonne.title")
                                                      ) +
                                                        ": " +
                                                        _vm._s(entry.kolonne) +
                                                        ", " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tours.expecteddate"
                                                          )
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            entry.startdate,
                                                            "DD.MM.YYYY"
                                                          )
                                                        )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "cell medium-6" }, [
                                    _c(
                                      "div",
                                      { staticClass: "form-block" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group",
                                            class: {
                                              "form-group--error":
                                                _vm.$v.object.location_id
                                                  .$error,
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for: "form-field-location",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "form.project.location"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("v-select-location", {
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "form.project.location.plc"
                                                ),
                                                tabindex: 1,
                                                customerId:
                                                  _vm.$route.params.customer,
                                                isStatic:
                                                  _vm.isViewMethod ||
                                                  _vm.$store.getters
                                                    .userIsProjectManager ||
                                                  _vm.isCancelled,
                                              },
                                              on: {
                                                change: _vm.onChangeLocation,
                                              },
                                              model: {
                                                value:
                                                  _vm.$v.object.location_id
                                                    .$model,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.$v.object.location_id,
                                                    "$model",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "$v.object.location_id.$model",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "form-group form-group--info",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "form.project.project_number"
                                                )
                                              ) +
                                                ": " +
                                                _vm._s(
                                                  _vm.object.project_number
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "form-group form-group--info",
                                          },
                                          [
                                            _vm._v(
                                              "\n                              " +
                                                _vm._s(
                                                  _vm.$t("createdon_date")
                                                ) +
                                                ": " +
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    _vm.object.createdon.date,
                                                    _vm.$helpers.dateFormat.toUpperCase()
                                                  )
                                                ) +
                                                "\n                              "
                                            ),
                                            _vm.$store.getters.userIsAdmin &&
                                            _vm.object.createdby
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "u-color--gray",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(
                                                          _vm.$t("search.from")
                                                        ) +
                                                        "\n                                " +
                                                        _vm._s(
                                                          _vm.object.createdby
                                                            .profile.firstname
                                                        ) +
                                                        "\n                                " +
                                                        _vm._s(
                                                          _vm.object.createdby
                                                            .profile.lastname
                                                        ) +
                                                        "\n                              "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.$store.getters.userIsAdmin &&
                                            _vm.object.createdby_ipaddress
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "u-color--gray",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                  IP-Adresse:   " +
                                                        _vm._s(
                                                          _vm.object
                                                            .createdby_ipaddress
                                                        ) +
                                                        "\n                              "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.$store.getters.userIsAdmin
                                          ? [
                                              _vm.object.tour_routes
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-group form-group--info",
                                                    },
                                                    _vm._l(
                                                      _vm.object.tour_routes,
                                                      function (route, index) {
                                                        return _c(
                                                          "p",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "u-extra-small-margin--bottom",
                                                          },
                                                          [
                                                            _c(
                                                              "router-link",
                                                              {
                                                                staticClass:
                                                                  "c-link--secondary",
                                                                attrs: {
                                                                  to: {
                                                                    name: "update-tour",
                                                                    params: {
                                                                      tour: route.tour_id,
                                                                    },
                                                                  },
                                                                  title:
                                                                    _vm.$t(
                                                                      "update"
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    route.tour_number
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "cell medium-6" }, [
                                    _c("div", { staticClass: "form-block" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group",
                                          class: {
                                            "form-group--error":
                                              _vm.$v.object.account_id.$error,
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { attrs: { for: "form-field-pm" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("form.project.pm")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-select-user", {
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "form.project.pm.plc"
                                              ),
                                              tabindex: 2,
                                              userType:
                                                _vm.$helpers.usertypes.pm,
                                              locationId:
                                                _vm.$v.object.location_id
                                                  .$model,
                                              customerId:
                                                _vm.$route.params.customer,
                                              isStatic:
                                                _vm.isViewMethod ||
                                                _vm.$store.getters
                                                  .userIsProjectManager ||
                                                _vm.isCancelled,
                                            },
                                            on: { change: _vm.onChangeAccount },
                                            model: {
                                              value:
                                                _vm.$v.object.account_id.$model,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.$v.object.account_id,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.object.account_id.$model",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "form-group" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("mobile")) +
                                            ": " +
                                            _vm._s(
                                              _vm.object.account.profile
                                                .communication.mobile
                                            )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "form-group" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("phone")) +
                                            ": " +
                                            _vm._s(
                                              _vm.object.account.profile
                                                .communication.phone
                                            )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "form-group" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("mail")) +
                                            ": " +
                                            _vm._s(
                                              _vm.object.account.profile
                                                .communication.email
                                            )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("section", { staticClass: "box" }, [
                              _c("h2", [
                                _vm._v(
                                  _vm._s(_vm.$t("form.project.title.location"))
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.isCreateMethod
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "callout warning text-center",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "project.message.onestreetperproject"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "grid-x grid-margin-x" },
                                [
                                  _c("div", { staticClass: "cell medium-6" }, [
                                    _c("div", { staticClass: "form-block" }, [
                                      _c(
                                        "div",
                                        { staticClass: "grid-x grid-margin-x" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "cell xxlarge-5 medium-4",
                                            },
                                            [
                                              _vm.isViewMethod ||
                                              _vm.isCancelled
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-control form-control--static",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.object.address
                                                                .zipcode
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group",
                                                      class: {
                                                        "form-group--error":
                                                          _vm.$v.object.address
                                                            .zipcode.$error,
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.$v.object
                                                                .address.zipcode
                                                                .$model,
                                                            expression:
                                                              "$v.object.address.zipcode.$model",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "loading-spinner--input":
                                                            _vm.geocodeLoading,
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          id: "form-field-zipcode",
                                                          name: "zipcode",
                                                          placeholder:
                                                            _vm.$t(
                                                              "form.zipcode.plc"
                                                            ),
                                                          tabindex: 3,
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.$v.object
                                                              .address.zipcode
                                                              .$model,
                                                        },
                                                        on: {
                                                          keyup:
                                                            _vm.onChangeZipcode,
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.$v.object
                                                                .address
                                                                .zipcode,
                                                              "$model",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "cell xxlarge-7 medium-8",
                                            },
                                            [
                                              _vm.isViewMethod ||
                                              _vm.isCancelled
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-control form-control--static",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.object.address
                                                                .city
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group",
                                                      class: {
                                                        "form-group--error":
                                                          _vm.$v.object.address
                                                            .city.$error,
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.$v.object
                                                                .address.city
                                                                .$model,
                                                            expression:
                                                              "$v.object.address.city.$model",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "loading-spinner--input":
                                                            _vm.geocodeLoading,
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          id: "form-field-city",
                                                          name: "city",
                                                          placeholder:
                                                            _vm.$t(
                                                              "form.city.plc"
                                                            ),
                                                          tabindex: 4,
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.$v.object
                                                              .address.city
                                                              .$model,
                                                        },
                                                        on: {
                                                          keyup:
                                                            _vm.onChangeCity,
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.$v.object
                                                                .address.city,
                                                              "$model",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "grid-x grid-margin-x" },
                                        [
                                          !_vm.isViewMethod && !_vm.isCancelled
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "cell xxlarge-12 large-4",
                                                },
                                                [
                                                  _vm.geocodeObject.zipcode
                                                    .length > 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-group form-group__extra",
                                                        },
                                                        [
                                                          _c(
                                                            "select",
                                                            {
                                                              staticClass:
                                                                "form-control form-control--select",
                                                              attrs: {
                                                                name: "zipcode_list",
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.onSelectZipcode,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "form.zipcode.choose"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                _vm
                                                                  .geocodeObject
                                                                  .zipcode,
                                                                function (
                                                                  item,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      key: index,
                                                                      domProps:
                                                                        {
                                                                          value:
                                                                            item.zipcode,
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.zipcode
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                            ],
                                                            2
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isViewMethod && !_vm.isCancelled
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "cell xxlarge-12 large-8",
                                                },
                                                [
                                                  _vm.geocodeObject.city
                                                    .length > 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-group form-group__extra",
                                                        },
                                                        [
                                                          _c(
                                                            "select",
                                                            {
                                                              staticClass:
                                                                "form-control form-control--select",
                                                              attrs: {
                                                                name: "city_list",
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.onSelectCity,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "form.city.choose"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                _vm
                                                                  .geocodeObject
                                                                  .city,
                                                                function (
                                                                  item,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      key: index,
                                                                      domProps:
                                                                        {
                                                                          value:
                                                                            item.city,
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.city
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                            ],
                                                            2
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "grid-x grid-margin-x" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cell medium-8" },
                                            [
                                              _vm.isViewMethod ||
                                              _vm.isCancelled
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-control form-control--static",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.object.address
                                                                .street
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group",
                                                      class: {
                                                        "form-group--error":
                                                          _vm.$v.object.address
                                                            .street.$error,
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.$v.object
                                                                .address.street
                                                                .$model,
                                                            expression:
                                                              "$v.object.address.street.$model",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "text",
                                                          id: "form-field-street",
                                                          name: "street",
                                                          placeholder:
                                                            _vm.$t(
                                                              "form.street.plc"
                                                            ),
                                                          tabindex: 5,
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.$v.object
                                                              .address.street
                                                              .$model,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.$v.object
                                                                .address.street,
                                                              "$model",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "cell medium-4" },
                                            [
                                              _vm.isViewMethod ||
                                              _vm.isCancelled
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-control form-control--static",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.object.address
                                                                .housenumber
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group",
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.object.address
                                                                .housenumber,
                                                            expression:
                                                              "object.address.housenumber",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "text",
                                                          id: "form-field-housenumber",
                                                          name: "housenumber",
                                                          placeholder: _vm.$t(
                                                            "form.housenumber.plc"
                                                          ),
                                                          tabindex: 6,
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.object.address
                                                              .housenumber,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.object
                                                                .address,
                                                              "housenumber",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isViewMethod || _vm.isCancelled
                                        ? _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "form.project.site_comments"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-control form-control--static form-control--textarea",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.object.site_comments
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "form.project.site_comments"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.object.site_comments,
                                                    expression:
                                                      "object.site_comments",
                                                  },
                                                ],
                                                staticClass:
                                                  "form-control form-control--textarea",
                                                attrs: {
                                                  id: "form-field-site-comments",
                                                  name: "site_comments",
                                                  placeholder: _vm.$t(
                                                    "form.project.site_comments.plc"
                                                  ),
                                                  tabindex: 7,
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.object.site_comments,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.object,
                                                      "site_comments",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _vm.isViewMethod || _vm.isCancelled
                                        ? _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "form.project.site_contact_label"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-control form-control--static form-control--textarea",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.object
                                                        .site_contact_info
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "form.project.site_contact_label"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.object
                                                        .site_contact_info,
                                                    expression:
                                                      "object.site_contact_info",
                                                  },
                                                ],
                                                staticClass:
                                                  "form-control--textarea",
                                                attrs: {
                                                  id: "form-field-site-contact-info",
                                                  name: "site_contact_info",
                                                  placeholder: _vm.$t(
                                                    "form.project.site_contact_info.plc"
                                                  ),
                                                  tabindex: 8,
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.object
                                                      .site_contact_info,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.object,
                                                      "site_contact_info",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _vm.isViewMethod || _vm.isCancelled
                                        ? _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "form.project.internal_number"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-control form-control--static form-control--textarea form-control--highlighted",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.object.internal_number
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "form-group",
                                              class: {
                                                "form-group--error":
                                                  _vm.$v.object.internal_number
                                                    .$error,
                                              },
                                            },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "form.project.internal_number"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.$v.object
                                                        .internal_number.$model,
                                                    expression:
                                                      "$v.object.internal_number.$model",
                                                  },
                                                ],
                                                staticClass:
                                                  "form-control form-control--textarea form-control--highlighted",
                                                attrs: {
                                                  id: "form-field-internal-number",
                                                  name: "internal_number",
                                                  placeholder: _vm.$t(
                                                    "form.project.internal_number.plc"
                                                  ),
                                                  tabindex: 9,
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.$v.object
                                                      .internal_number.$model,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.$v.object
                                                        .internal_number,
                                                      "$model",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "cell medium-6" }, [
                                    _c("div", { staticClass: "form-block" }, [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-control form-control--maps",
                                          },
                                          [
                                            _c("v-google-map", {
                                              attrs: {
                                                address:
                                                  _vm.object.address.street +
                                                  " " +
                                                  _vm.object.address
                                                    .housenumber +
                                                  " " +
                                                  _vm.object.address.city +
                                                  " " +
                                                  _vm.object.address.zipcode,
                                                resize: !_vm.isLoading,
                                                lat: _vm.object.lat,
                                                lon: _vm.object.lon,
                                                tabindex: -1,
                                                zoom: 10,
                                                zoomControl: true,
                                                panControl: true,
                                                useFitBounds: false,
                                              },
                                              on: {
                                                marker: _vm.getMarker,
                                                noAddressFound:
                                                  _vm.noAddressFound,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.isViewMethod || _vm.isCancelled
                                        ? _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "form-field-location",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "form.project.requested_deadline"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-control form-control--static",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.object
                                                        .requested_deadline
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "form-field-location",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "form.project.requested_deadline"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.object
                                                        .requested_deadline,
                                                    expression:
                                                      "object.requested_deadline",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "text",
                                                  id: "form-field-requested-deadline",
                                                  name: "requested_deadline",
                                                  placeholder: _vm.$t(
                                                    "form.project.requested_deadline.plc"
                                                  ),
                                                  tabindex: 10,
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.object
                                                      .requested_deadline,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.object,
                                                      "requested_deadline",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.$store.getters.userIsAdmin
                              ? _c("section", { staticClass: "box" }, [
                                  _c(
                                    "div",
                                    { staticClass: "grid-x grid-margin-x" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "cell small-12" },
                                        [
                                          _c("h2", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "project.internalarea.title"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "cell small-12" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "form-block" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "project.internal_note"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.object
                                                            .internal_note,
                                                        expression:
                                                          "object.internal_note",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-control form-control--textarea",
                                                    attrs: {
                                                      id: "form-field-internal-note",
                                                      name: "internal_note",
                                                      tabindex: 11,
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.object
                                                          .internal_note,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.object,
                                                          "internal_note",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "cell medium-12 large-6" }, [
                            _c("div", { staticClass: "box" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "grid-x grid-margin-x grid-padding-x",
                                },
                                [
                                  _c("div", { staticClass: "cell medium-7" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "loading-wrapper",
                                        class: {
                                          "is-loading": _vm.layersLoading,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "loading-message" },
                                          [
                                            _vm._v(
                                              _vm._s(this.$t("results_loading"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "layer-stats layer-stats--overview",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "layer-stats--overview__item layer-stats--overview__item--total",
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$helpers.formatNumber(
                                                        _vm.layersStats.total
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(
                                                  "\n                                  " +
                                                    _vm._s(_vm.$t("qm_total")) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "layer-stats--overview__item layer-stats--overview__item--finished",
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$helpers.formatNumber(
                                                        _vm.layersStats.finished
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(
                                                  "\n                                  " +
                                                    _vm._s(
                                                      _vm.$t("status.finished")
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "layer-stats--overview__item layer-stats--overview__item--open",
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$helpers.formatNumber(
                                                        _vm.layersStats.open
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(
                                                  "\n                                  " +
                                                    _vm._s(
                                                      _vm.$t("status.open")
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "cell medium-5" }, [
                                    _c("div", { staticClass: "form-block" }, [
                                      _vm.isViewMethod || _vm.isCancelled
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group form-group--check form-group--check--static",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "large" },
                                                [
                                                  _c("span", {
                                                    staticClass: "checkbox",
                                                    class: {
                                                      checked:
                                                        _vm.object.layer_hole,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("i"),
                                                  _vm._v(
                                                    "\n                                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "form.project.layer_hole"
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group form-group--check",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "large" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.object.layer_hole,
                                                        expression:
                                                          "object.layer_hole",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "checkbox",
                                                      name: "layer_hole",
                                                      value: "1",
                                                    },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.object.layer_hole
                                                      )
                                                        ? _vm._i(
                                                            _vm.object
                                                              .layer_hole,
                                                            "1"
                                                          ) > -1
                                                        : _vm.object.layer_hole,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.object
                                                              .layer_hole,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = "1",
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.object,
                                                                "layer_hole",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.object,
                                                                "layer_hole",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.object,
                                                            "layer_hole",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("i"),
                                                  _vm._v(
                                                    "\n                                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "form.project.layer_hole"
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _vm.isViewMethod || _vm.isCancelled
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group form-group--check form-group--check--static",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "large" },
                                                [
                                                  _c("span", {
                                                    staticClass: "checkbox",
                                                    class: {
                                                      checked:
                                                        _vm.object.layer_tok,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("i"),
                                                  _vm._v(
                                                    "\n                                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "form.project.layer_tok"
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group form-group--check",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "large" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.object.layer_tok,
                                                        expression:
                                                          "object.layer_tok",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "checkbox",
                                                      name: "layer_tok",
                                                      value: "1",
                                                    },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.object.layer_tok
                                                      )
                                                        ? _vm._i(
                                                            _vm.object
                                                              .layer_tok,
                                                            "1"
                                                          ) > -1
                                                        : _vm.object.layer_tok,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.object
                                                              .layer_tok,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = "1",
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.object,
                                                                "layer_tok",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.object,
                                                                "layer_tok",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.object,
                                                            "layer_tok",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("i"),
                                                  _vm._v(
                                                    "\n                                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "form.project.layer_tok"
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _vm.isViewMethod || _vm.isCancelled
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group form-group--check form-group--check--static",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "large" },
                                                [
                                                  _c("span", {
                                                    staticClass: "checkbox",
                                                    class: {
                                                      checked:
                                                        _vm.object
                                                          .layer_installation,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("i"),
                                                  _vm._v(
                                                    "\n                                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "form.project.layer_installation"
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group form-group--check",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "large" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.object
                                                            .layer_installation,
                                                        expression:
                                                          "object.layer_installation",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "checkbox",
                                                      name: "layer_installation",
                                                      value: "1",
                                                    },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.object
                                                          .layer_installation
                                                      )
                                                        ? _vm._i(
                                                            _vm.object
                                                              .layer_installation,
                                                            "1"
                                                          ) > -1
                                                        : _vm.object
                                                            .layer_installation,
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$a =
                                                              _vm.object
                                                                .layer_installation,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = "1",
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                _vm.$set(
                                                                  _vm.object,
                                                                  "layer_installation",
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ])
                                                                )
                                                            } else {
                                                              $$i > -1 &&
                                                                _vm.$set(
                                                                  _vm.object,
                                                                  "layer_installation",
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    )
                                                                )
                                                            }
                                                          } else {
                                                            _vm.$set(
                                                              _vm.object,
                                                              "layer_installation",
                                                              $$c
                                                            )
                                                          }
                                                        },
                                                        _vm.onChangeLayerInstallation,
                                                      ],
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("i"),
                                                  _vm._v(
                                                    "\n                                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "form.project.layer_installation"
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                this.object.layer_installation,
                                              expression:
                                                "this.object.layer_installation",
                                            },
                                          ],
                                          staticClass:
                                            "form-group form-group--check",
                                          class: {
                                            "form-group--check--static":
                                              _vm.isViewMethod,
                                          },
                                        },
                                        [
                                          _vm.isViewMethod || _vm.isCancelled
                                            ? _c(
                                                "label",
                                                { staticClass: "large" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "form.project.layer_width"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "label",
                                                { staticClass: "large" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "form.project.layer_width"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group-toggle",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "grid-container full",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "grid-x" },
                                                    [
                                                      _vm.isViewMethod ||
                                                      _vm.isCancelled
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cell medium-4 large-5",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-control form-control--small form-control--static",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.object
                                                                        .layer_width_min
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cell medium-4 large-5",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.object
                                                                        .layer_width_min,
                                                                    expression:
                                                                      "object.layer_width_min",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control form-control--small",
                                                                attrs: {
                                                                  type: "text",
                                                                  id: "form-element-layer-width-min",
                                                                  name: "layer_width_min",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.object
                                                                      .layer_width_min,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.$set(
                                                                        _vm.object,
                                                                        "layer_width_min",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "cell medium-3 large-auto",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-control form-control--small form-control--seperator",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t("till")
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.isViewMethod ||
                                                      _vm.isCancelled
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cell medium-4 large-5",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-control form-control--small form-control--static",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.object
                                                                        .layer_width_max
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cell medium-4 large-5",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.object
                                                                        .layer_width_max,
                                                                    expression:
                                                                      "object.layer_width_max",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control form-control--small",
                                                                attrs: {
                                                                  type: "text",
                                                                  id: "form-element-layer-width-min",
                                                                  name: "layer_width_max",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.object
                                                                      .layer_width_max,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.$set(
                                                                        _vm.object,
                                                                        "layer_width_max",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "box" }, [
                              _c("h2", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("form.project.title.default_layers")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "layers layers--overview loading-wrapper",
                                  class: { "is-loading": _vm.layersLoading },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "loading-message" },
                                    [_vm._v(_vm._s(this.$t("results_loading")))]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.sortLayers,
                                    function (layer, index) {
                                      return _c(
                                        "div",
                                        { key: index },
                                        [
                                          layer.is_default
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "layers--overview__item",
                                                  },
                                                  [
                                                    _c("v-project-layer", {
                                                      attrs: {
                                                        layer: layer,
                                                        projectId:
                                                          _vm.object.id,
                                                        isStatic:
                                                          _vm.isViewMethod ||
                                                          _vm.isCancelled,
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.onChangeLayer,
                                                        changeField:
                                                          _vm.onUpdateLayersStats,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.$v.object.layers
                                                            .$each.$iter[
                                                            layer.id
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.$v.object.layers
                                                              .$each.$iter,
                                                            layer.id,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "$v.object.layers.$each.$iter[layer.id]",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "box" }, [
                              _c("div", { staticClass: "box__title" }, [
                                _c("h2", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "form.project.title.addition_layers"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "form.project.title.addition_layers.total",
                                        {
                                          total: _vm.$helpers.formatNumber(
                                            _vm.layersStats.layers.addition
                                          ),
                                        }
                                      )
                                    ),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "layers layers--overview loading-wrapper",
                                  class: { "is-loading": _vm.layersLoading },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "loading-message" },
                                    [_vm._v(_vm._s(this.$t("results_loading")))]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.sortLayers,
                                    function (layer, index) {
                                      return _c(
                                        "div",
                                        { key: index },
                                        [
                                          !layer.is_default
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "layers--overview__item",
                                                  },
                                                  [
                                                    _c("v-project-layer", {
                                                      attrs: {
                                                        layer: layer,
                                                        projectId:
                                                          _vm.object.id,
                                                        isStatic:
                                                          _vm.isViewMethod ||
                                                          _vm.isCancelled,
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.onChangeLayer,
                                                        changeField:
                                                          _vm.onUpdateLayersStats,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.$v.object.layers
                                                            .$each.$iter[
                                                            layer.id
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.$v.object.layers
                                                              .$each.$iter,
                                                            layer.id,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "$v.object.layers.$each.$iter[layer.id]",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-upload-dialog", {
                      attrs: {
                        projectId: _vm.$route.params.project,
                        method: _vm.upload.method,
                        isVisible: _vm.upload.isVisible,
                      },
                      on: { onAction: _vm.onChangeUpload },
                      model: {
                        value: _vm.upload.media,
                        callback: function ($$v) {
                          _vm.$set(_vm.upload, "media", $$v)
                        },
                        expression: "upload.media",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }